import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule , getBaseUrl} from './app/app.module';
import { environment } from './environments/environment';
import posthog from 'posthog-js';
import { initPosthog } from './app/services/posthog.service';

if (environment.faviconUrl) {
  document.querySelectorAll<HTMLLinkElement>('link[rel="icon"], link[rel="shortcut icon"]')
    .forEach(link => link.href = environment.faviconUrl as string);
}

  const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];




if (environment.production) {
  // Désactive les console.log() en prod
  if (window) {
    window.console.log = function () { };
    window.console.table = function () { };
    window.console.assert = function () { };
    window.console.clear = function () { };
    window.console.count = function () { };
    window.console.debug = function () { };
    window.console.dir = function () { };
    window.console.error = function () { };
    //window.console.exception = function () { };
    window.console.info = function () { };
    window.console.time = function () { };
    window.console.trace = function () { };
    window.console.warn = function () { };
  }
}

initPosthog();

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => {
    if (posthog.__loaded) {
      posthog.captureException(err);
    }
    console.error(err);
  });
